/**
 * Stacking for fullscreen / PiP video vs Chakra portals (drawers, modals, menus).
 *
 * `ChakraProvider` `portalZIndex` wraps every portaled subtree in a host with that
 * z-index; it must stay above {@link VIDEO_CALL_RND_Z_INDEX} or drawers never clear
 * the call UI.
 */
export const MESSAGE_ATTACHMENT_UPLOAD_PROGRESS_Z_INDEX = 5;

/**
 * Ensures the pinned-thread hover trigger (ellipsis) stays above the thread card.
 * Small/local stacking only (popover content is portaled).
 */
export const PINNED_MESSAGE_THREAD_HOVER_TRIGGER_Z_INDEX = 9;

/**
 * Hover stacking so the "seen" popover renders above message chrome/popovers.
 * Keep small; this is for local stacking context, not global overlays.
 */
export const MESSAGE_SEEN_HOVER_Z_INDEX = 11;

/** Admin table action menu (select action). */
export const ADMIN_TABLE_ACTION_MENU_Z_INDEX = 11;

/** Drag-and-drop overlay shown when dragging files over composer. */
export const MESSAGE_COMPOSER_DROP_OVERLAY_Z_INDEX = 99;

/** Admin export CSV menu; keep above table headers/etc. */
export const ADMIN_EXPORT_MENU_Z_INDEX = 100;

/** Sticky header in internal-admin left nav. */
export const INTERNAL_ADMIN_LEFT_NAV_STICKY_HEADER_Z_INDEX = 100;

/** Raised stacking while dragging pinned message threads. */
export const PINNED_MESSAGE_THREAD_DRAG_Z_INDEX = 1000;

/** Floating-ui popper must clear Chakra drawer (1400). */
export const FLOATING_UI_POPPER_Z_INDEX = 1401;

export const VIDEO_CALL_RND_Z_INDEX = 9997;

/** Use as ChakraProvider `portalZIndex` in app shells that mount VideoCallProvider. */
export const CHAKRA_PORTAL_HOST_Z_INDEX = 9998;

/** Update-available prompt should float above most UI. */
export const APP_UPDATE_PROMPT_Z_INDEX = 9999;

/**
 * Portaled menus (e.g. react-select) should sit above most page content.
 * Keep below {@link FILE_MODAL_CLOSE_BUTTON_Z_INDEX} so modal chrome always wins.
 */
export const SELECT_MENU_PORTAL_Z_INDEX = 9999;

/** File gallery arrow buttons inside modals/overlays. */
export const FILE_GALLERY_NAV_Z_INDEX = 10_000;

/** Close button should always be on top of file modals. */
export const FILE_MODAL_CLOSE_BUTTON_Z_INDEX = 10_001;

export const MAINTENANCE_PAGE_Z_INDEX = 10_100;
